module.exports = __webpack_public_path__ + "img/windows.35595f5.png";